import { Dispatch, SetStateAction } from 'react';
import { EnumTechTool } from 'tdc-web-backend/enums/enums';
import { Stack } from '@mui/system';
import CustomChip from '../../../../../../../../../components/custom-chip/CustomChip';
import { mapTechTool } from '../../../../../../../../../utils/enums';
import { truncate } from '../../../../../../../../../utils/helpers';
import CompanyTechToolsEditModal from './components/CompanyTechToolsEditModal';
import useUserCompany from '../../../../../../../../../utils/hooks/useUserCompany';
import { CHIP_LABEL_TRUNCATE_VALUE } from '../../../../../../../../../utils/constants';

interface CompanyTechToolsProps {
  isEditModalOpen: boolean;
  setIsEditModalOpen: Dispatch<SetStateAction<boolean>>;
}

const CompanyTechTools = ({ isEditModalOpen, setIsEditModalOpen }: CompanyTechToolsProps) => {
  const { company: companyData } = useUserCompany();

  return (
    <Stack
      direction="row"
      gap={1}
      flexWrap="wrap"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      {companyData?.techTools?.map((tool: EnumTechTool) => (
        <CustomChip
          key={tool}
          tooltipTitle={mapTechTool.get(tool)}
          label={
            tool && truncate(mapTechTool.get(tool) as string, CHIP_LABEL_TRUNCATE_VALUE as number)
          }
          sx={{ width: 'fit-content', textTransform: 'capitalize' }}
        />
      ))}

      {companyData && isEditModalOpen && (
        <CompanyTechToolsEditModal
          isEditModalOpen={isEditModalOpen}
          setIsEditModalOpen={setIsEditModalOpen}
        />
      )}
    </Stack>
  );
};

export default CompanyTechTools;
